/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import uniqBy from "lodash/uniqBy";
import { Route } from "react-router-dom";
import { message, Spin, Modal } from "antd";
import { jwtDecode } from "jwt-decode";
import { fetchInitiators, fetchTaskStatus, fetchTaskTypes } from "../../store/slices/tasks";
import {
  fetchBillStatus,
  fetchBillType,
  fetchPayStatus,
  fetchTaskStatusDict,
  fetchUserScope,
} from "../../store/slices/rtkDictionaries";
import { getReprocessTaskRoute } from "../../lib/routes/tasks-manager";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import TaskDetalizationContainer from "../TaskDetalizationContainer/TaskDetalizationContainer";
import TaskListContainer from "../TaskListContainer/TaskListContainer";
import AuthService from "../../services/AuthService";

const TasksContainer = () => {
  const dispatch = useDispatch();
  const { tasks, tasksLoading, taskTypesLoading } = useSelector((state) => state.tasks);
  const { billStatusLoading, billTypeLoading, payStatusLoading } = useSelector(
    (state) => state.rtkDictionaries
  );

  const userName = jwtDecode(AuthService.getCurrentUser());

  const [isModalConfirmationVisible, setIsModalConfirmationVisible] = useState(false);
  const [taskIdForReprocess, setTaskIdForReprocess] = useState();
  const [mainTask, setMainTask] = useState();
  const [filters, setFilters] = useState({ userScopeId: [1, 3] });
  const [taskListPage, setTaskListPage] = useState(1);
  const [isReprocessRunning, setIsReprocessRunning] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState(null);

  useEffect(() => {
    dispatch(fetchTaskTypes());
    dispatch(fetchTaskStatusDict());
    dispatch(fetchBillStatus());
    dispatch(fetchBillType());
    dispatch(fetchPayStatus());
    dispatch(fetchUserScope());
  }, [dispatch]);

  useEffect(() => {
    if (checkIsLoaded(tasksLoading)) {
      dispatch(
        fetchInitiators({ initiatorsIds: uniqBy(tasks.content.map((task) => task.userId)) })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tasksLoading]);

  const runReprocessTask = (subtaskId) => {
    setIsReprocessRunning(true);
    axios.post(getReprocessTaskRoute(subtaskId)).then(() => {
      setTimeout(() => {
        dispatch(fetchTaskStatus({ taskId: mainTask }));
        message.success("Задание перезапущено");
        setIsReprocessRunning(false);
      }, 1000);
    }).catch(() => {
      message.destroy()
      message.error("Ошибка перезапуска задания");
      setIsReprocessRunning(false);
    });
  };

  if (checkIsLoaded(billStatusLoading, billTypeLoading, payStatusLoading, taskTypesLoading)) {
    return (
      <div className="container_height">
        <Modal
          cancelText="Отмена"
          okText="Далее"
          visible={isModalConfirmationVisible}
          onCancel={() => setIsModalConfirmationVisible(false)}
          onOk={() => {
            runReprocessTask(taskIdForReprocess || currentTaskId);
            setIsModalConfirmationVisible(false);
          }}
          zIndex={1001}
        >
          <p style={{ paddingTop: "30px", textAlign: "center" }}>
            Будет сформировано задание на выполнение операции. Для продолжения нажмите «Далее».
          </p>
        </Modal>
        <Route exact path="/tasks">
          <TaskListContainer
            setIsModalConfirmationVisible={setIsModalConfirmationVisible}
            setTaskIdForReprocess={setTaskIdForReprocess}
            filters={filters}
            setFilters={setFilters}
            currentPage={taskListPage}
            setCurrentPage={setTaskListPage}
            setMainTask={setMainTask}
            isReprocessRunning={isReprocessRunning}
            currentTaskId={currentTaskId}
            setCurrentTaskId={setCurrentTaskId}
          />
        </Route>
        <Route path="/tasks/:taskId/detalization">
          <TaskDetalizationContainer
            setIsModalConfirmationVisible={setIsModalConfirmationVisible}
            setTaskIdForReprocess={setTaskIdForReprocess}
            runReprocessTask={runReprocessTask}
          />
        </Route>
      </div>
    );
  }
  return <Spin className="spin" />;
};

export default TasksContainer;
